'use client'

import { memo } from 'react'
import Link from 'next/link'
import { NinSocialIconLinks } from '@/app/(marketing)/_components/nin-social-icon-links'
import { NIN_BLOGS_URL, NIN_LEARN_URL } from '@/app/nin/_components/nin-org-links'

/** baby: Same links/socials as classic /ninxl footer: craft styling only (no theme toggle). */
export const CraftFooter = memo(function CraftFooter() {
  return (
    <footer className="craft-footer">
      <div className="craft-footer__inner craft-footer__inner--classic">
        <div className="craft-footer__links">
          <Link href={NIN_LEARN_URL}>Learn</Link>
          <Link href={NIN_BLOGS_URL}>Blogs</Link>
          <Link href="/ningenie/policies/terms-of-service">Terms</Link>
          <Link href="/ningenie/policies/privacy-policy">Privacy</Link>
        </div>
        <div className="craft-footer__meta">
          <NinSocialIconLinks />
          <p>© 2026 NIN. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
})

CraftFooter.displayName = 'CraftFooter'
